module.exports = __webpack_public_path__ + "static/logo-8b0689a091d1de72b1de0d0189bf526b.svg";